import { createApp } from "vue";
import App from "./App.vue";
import Maintenance from "./pages/Maintenance.vue"; // Maintenance Page
import router from "./router";
import store from "./store";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "./assets/css/main.css";

// jQuery and JS plugins (your original setup)
import $ from "jquery";
import WOW from "wowjs";
window.$ = window.jQuery = $;
new WOW.WOW().init();

// Vendor JS files
import "./assets/js/vendor/modernizr-3.5.0.min.js";
import "./assets/js/vendor/jquery.min.js";
import "./assets/js/popper.min.js";
import "./assets/js/bootstrap.min.js";
import "./assets/js/slick.min.js";
import "./assets/js/ajax-form.js";
import "./assets/js/paroller.js";
import "./assets/js/wow.min.js";
import "./assets/js/js_isotope.pkgd.min.js";
import "./assets/js/imagesloaded.min.js";
import "./assets/js/parallax.min.js";
import "./assets/js/jquery.waypoints.min.js";
import "./assets/js/jquery.counterup.min.js";
import "./assets/js/jquery.scrollUp.min.js";
import "./assets/js/jquery.meanmenu.min.js";
import "./assets/js/parallax-scroll.js";
import "./assets/js/jquery.magnific-popup.min.js";
import "./assets/js/element-in-view.js";
import "./assets/js/main.js";
import "bootstrap-icons/font/bootstrap-icons.css";

//Import Bootstrap JS (for modals, dropdowns, etc.)
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// ✅ Maintenance flag
// const MAINTENANCE_MODE = process.env.NODE_ENV == "development" ? false : true;
const MAINTENANCE_MODE = false; // Set to true to enable maintenance mode

const app = createApp(MAINTENANCE_MODE ? Maintenance : App);

// Always load plugins
app.use(router);
app.use(store);

// ⛔ Do NOT add maintenance route here unless you're selectively showing it.
// You’ve already swapped the component above.

app.mount("#app");
